// decorators/data-loaded-field.ts
import { getArrayDepth, unwrapType } from "../metadata/types.js";
import { loadMongoData } from "../server/data-loader.js";
import { registerField } from "./field.js";
function DataLoadedField(type, getFilter, options = {}) {
  return (target, propertyName) => {
    registerField(target, type, propertyName, {
      ...options,
      // TODO this returns plain data and not entities, do we want that?
      resolve() {
        if (this[propertyName] !== void 0) {
          if (this[propertyName] !== null)
            return () => this[propertyName];
        }
        const filter = getFilter(this);
        if (!filter)
          return () => null;
        return async () => {
          const isArray = getArrayDepth(type)() > 0;
          const loadedData = await loadMongoData(unwrapType(type)(), filter, options.sort);
          const filterIsQuery = typeof filter === "object" && !Array.isArray(filter);
          if (filterIsQuery && !isArray) {
            if (loadedData.length > 1)
              throw new Error(
                `implied findOne in DataLoadedField filter, but ${loadedData.length} results have been found instead of one`
              );
            return loadedData[0];
          }
          return loadedData;
        };
      }
    });
  };
}
export {
  DataLoadedField
};
